import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { StripeSuccessComponent } from '../components/stripe-success/stripe-success.component';
import { StripeRedirectComponent } from '../components/stripe-redirect/stripe-redirect.component';
import { BraintreeCheckoutComponent } from '../components/braintree-checkout/braintree-checkout.component';

/**
 * Declares Stripe payment UI components (StripeSuccessComponent, StripeRedirectComponent).
 * Import this module wherever these components are used as route targets.
 * - AdhocInvoiceModule  (adhoc-invoice/payment/stripe-success)
 * - SubscriptionsModule (subscriptions/payment/stripe-success)
 */
@NgModule({
  declarations: [
    StripeSuccessComponent,
    StripeRedirectComponent,
    BraintreeCheckoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    StripeSuccessComponent,
    StripeRedirectComponent,
    BraintreeCheckoutComponent
  ]
})
export class PaymentComponentsModule {}
